import { defaultVelasProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/velas/default-constants';

export const WAGYU_SWAP_CONTRACT_ADDRESS = '0x3D1c58B6d4501E34DF37Cf0f664A58059a188F00';

export const WAGYU_SWAP_PROVIDER_CONFIGURATION = defaultVelasProviderConfiguration;
